/* filter data for shipment */


export const namespaced = true

export const state = {
    wholesaler_id_list :[],
    filter_date_from : "",
    filter_date_to : "",
    filter_count:0,
}

export const mutations = {
    SET_WITHDRAWAL_FILTER(state, {
        wholesaler_id_list,
        filter_date_from,
        filter_date_to,
        filter_count,
    }) {
        state.wholesaler_id_list = wholesaler_id_list
        state.filter_date_from = filter_date_from
        state.filter_date_to = filter_date_to
        state.filter_count = filter_count
    },
}
export const actions = {
    setWithdrawalFilter({
        commit
    }, items) {
        commit('SET_WITHDRAWAL_FILTER', items)
    },
}
export const getters = {
    getWithdrawalFilter: state => {
        return state;
    },
}